var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.5 2.08389L1.84186 0.682129L9.5 8.68213L1.84186 16.6821L0.5 15.2804L6.81628 8.68213L0.5 2.08389Z","fill":"#383F49"}));
}

ArrowRightInline.defaultProps = {"width":"10","height":"17","viewBox":"0 0 10 17","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
